<div class="container-fluid">

  <!-- <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>

        <div class="row">
          <div class="col-lg-8">
            <div class="mb-3">
              <div class="position-relative">
                <label class="form-label">Date Range</label>
                <input type="text" class="form-control date" [value]="filterDates ? (formatDateRange(filterDates)) : ''"
                  placeholder="Select Date" name="daterange" autocomplete="off" bsDaterangepicker
                  [bsConfig]="datePickerConfig" [(bsValue)]="filterDates" (keydown)="preventManualInput($event)" />
                <span class="bx bx-calendar inputIcon" (click)="openCalendar()"></span>

                <span class="bx bx-x inputIcon clear-icon" *ngIf="filterDates.length>0" (click)="clearDate()"></span>
              </div>
            </div>
          </div>

          <div class="col-lg-4 d-flex align-items-center sm-btn">
            <button class="btn btn-primary btn-md mt-2" (click)="filterReadings('filter')">
              ExportAll
            </button>
           

          </div>
        </div>


      </div>
    </div>
  </div> -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">

        <!-- LEFT SIDE: Breadcrumb -->
        <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>

        <!-- RIGHT SIDE: Date Range + ExportAll -->
        @if(cdkStepper.selectedIndex === 1){
        <div class="d-flex align-items-end gap-3">

          <div class="date-range-box">
            <label class="form-label"></label>
            <div class="position-relative">
              <input type="text" class="form-control date" [(ngModel)]="exportDate" placeholder="Select Date"
                name="singleDate" autocomplete="off" bsDatepicker [bsConfig]="ExportdatePickerConfig"
                (keydown)="disableTyping($event)" />
              <span class="bx bx-calendar inputIcon" (click)="openCalendar()"></span>
              <span class="bx bx-x inputIcon clear-icon" *ngIf="exportDate" (click)="clearDate()"></span>
            </div>
          </div>

          <button class="btn btn-primary btn-md" [disabled]="exportDate?false:true" (click)="ArchivedExport()">
            ExportAll
          </button>

        </div>}

      </div>
    </div>
  </div>



  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">

          <div id="basic-example">
            <ng-stepper #cdkStepper [linear]="true" class="wizard" (selectionChange)="onStepChange($event)">

              <cdk-step [optional]="false">
                <ng-template cdkStepLabel>
                  <span class="number">1.</span>
                  <span>IOT Readings</span>
                </ng-template>
                <div class="col-lg-12">
                  <!-- <form> -->
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="mb-3">
                        <label class="form-label">Date Range</label>
                        <div class="position-relative">
                          <input type="text" class="form-control date" placeholder="Select Date"
                            [(ngModel)]="selectedDateRange" (bsValueChange)="onDateChange($event)"
                            (click)="hidden = !hidden" name="daterange" autocomplete="off" bsDaterangepicker
                            [bsConfig]="datePickerConfig" />
                          <span class="bx bx-calendar inputIcon" (click)="openCalendar()"></span>
                          <!-- Clear icon -->
                          <span class="bx bx-x inputIcon clear-icon" *ngIf="selectedDateRange?.length > 0"
                            (click)="IotclearDate()"></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 d-flex align-items-center sm-btn">
                      <button class="btn btn-primary btn-md mt-2" (click)="filterReadings('filter')">
                        Apply
                      </button>
                      <button class="btn btn-outline-primary btn-md mt-2 ms-2" (click)="filterReadings('reset')">
                        Reset
                      </button>

                    </div>
                  </div>
                </div>

                @if(cdkStepper.selectedIndex === 0){

                <section class="">
                  <ng-template #template let-anchor>
                    <span>{{ anchor.nativeElement.innerText }}</span>
                  </ng-template>
                  <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
                    (mouseover)="showTooltip($event)">
                    <kendo-grid [data]="readingsgridData" [pageSize]="reading_pageSize" [skip]="skip" [sortable]="true"
                      [groupable]="false" [selectable]="selectableSettings" [pageable]="{
                                                            buttonCount: buttonCount,
                                                            info: info,
                                                            type: type,
                                                            pageSizes: ArchpageSizes,
                                                            previousNext: previousNext
                                                          }" [reorderable]="true" filterable="menu"
                      [filter]="readingsstate.filter" [sort]="readingsstate.sort" [columnMenu]="{ filter: true }"
                      [resizable]="true" kendoGridSelectBy="id" scrollable="scrollable"
                      (filterChange)="onFilterChange($event)" (sortChange)="onSortChange($event)"
                      (pageChange)="devicePageChange($event)" (selectionChange)="selectionChanged($event)"
                      (dataStateChange)="dataStateChange($event)" style="width: 100%;" scrollable="scrollable">


                      <ng-template kendoGridToolbarTemplate>

                        <span style="color: red;">Note: All water readings are in Liters, gas readings are in cubic
                          meters (m³), and electricity readings are in kilowatt-hours (kWh).</span>

                        <kendo-grid-spacer></kendo-grid-spacer>
                        <!-- <button kendoGridPDFCommand class="btn btn-light">
                                                    <span class="fas fa-file-pdf"> </span> &nbsp; Export to PDF</button> -->
                        <button kendoGridExcelCommand class="btn btn-light" (click)="onReadingsExport('Excel')">
                          <span class="fas fa-file-excel"> </span> &nbsp; Export to Excel
                        </button>

                      </ng-template>

                      <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="40"
                        class="no-tooltip"></kendo-grid-checkbox-column>

                      <kendo-grid-column [width]="100" field="utilityType" title="Utility Type" [sortable]="false"
                        [filterable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <!-- Filter Operators for "Equal To", "Starts With", and "Ends With" -->
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>



                      <kendo-grid-column [width]="100" field="deviceSRNO" title="Device Sr No" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <!-- <kendo-filter-startswith-operator></kendo-filter-startswith-operator> -->
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column [width]="100" field="macAddress" title="Mac Address" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <!-- <kendo-filter-startswith-operator></kendo-filter-startswith-operator> -->
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column [width]="100" [hidden]="true" field="isMonitoringDevice" [filterable]="false"
                        title="Monitoring Device" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>
                      <!--                                                   
                                                  <kendo-grid-column [width]="100" field="date_Time" title="Date & time" filter="date">
                                                    <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
                                                      <kendo-grid-date-filter-menu
                                                        [column]="column"
                                                        [filter]="filter"
                                                        [filterService]="filterService"  [extra]="false">
                                                        <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                                        <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                                                      </kendo-grid-date-filter-menu>
                                                    </ng-template>
                                                  </kendo-grid-column> -->

                     <!--  <kendo-grid-column [width]="100" field="date_Time" title="Date & Time" filter="date">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.date_Time ? (dataItem.date_Time | date: 'dd MMM yyyy hh:mm a') : '' }}
                        </ng-template>


                       
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
                                                        <kendo-grid-date-filter-menu
                                                        [column]="column"
                                                        [filter]="filter"
                                                        [filterService]="filterService"
                                                        [extra]="false"
                                                        [operator]="'eq'">
                                                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                                                        </kendo-grid-date-filter-menu>
                                                    </ng-template>
                      
                      </kendo-grid-column> -->

                    <kendo-grid-column [width]="120" field="date_Time" title="Date & Time" filter="date">
                    
                      <!-- Cell Template -->
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.date_Time ? (dataItem.date_Time | date:'dd MMM yyyy hh:mm a') : '' }}
                      </ng-template>
                    
                      <!-- Filter Menu -->
                      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService"
                      [showOperators]="false">
                    
                        <kendo-grid-date-filter-menu [column]="column" [filter]="filter" [filterService]="filterService" [extra]="true"
                         >
                    
                        <!-- FIRST FILTER: Greater than or equal to -->
                        <kendo-filter-gte-operator></kendo-filter-gte-operator>
                        
                        <!-- SECOND FILTER: Less than or equal to -->
                        <kendo-filter-lte-operator></kendo-filter-lte-operator>
                        </kendo-grid-date-filter-menu>
                    
                      </ng-template>
                    
                    </kendo-grid-column>




                      <kendo-grid-column field="meterReading" filter="numeric" [filterable]="false"
                        title="Meter reading" [width]="100" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.meterReading === 0 ? '-' : dataItem.meterReading }}
                        </ng-template>
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-numeric-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-numeric-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="meterReadingEB" filter="numeric" [sortable]="false" [filterable]="false"
                        [filterable]="false" title="Meter Reading EB" [width]="100">
                        <!-- Filter code starts -->
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.meterReadingEB === 0 ? '-' : dataItem.meterReadingEB }}
                        </ng-template>
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-numeric-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-numeric-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="meterReadingDG" filter="numeric" [sortable]="false" [filterable]="false"
                        title="Meter Reading DG" [width]="100">
                        <!-- Filter code starts -->
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.meterReadingDG === 0 ? '-' : dataItem.meterReadingDG }}
                        </ng-template>
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-numeric-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-numeric-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="meterReadingTS" filter="numeric" [sortable]="false" [filterable]="false"
                        title="Meter Reading Ts" [width]="100">
                        <!-- Filter code starts -->
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.meterReadingTS === 0 ? '-' : dataItem.meterReadingTS }}
                        </ng-template>
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-numeric-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-numeric-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="onOffStatus" [hidden]="true" [sortable]="false" title="On / off status"
                        [filterable]="false" [width]="80">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="projectName" title="Project name" [sortable]="false"
                        [filterable]="false" [width]="100">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-command-column [columnMenu]="false" [width]="50" title="View Details">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <button class="btn btn-primary btn-sm m-lg-auto" kendoTooltip title="View Iot Reading Details"
                            (click)="navigateToViewReadings(dataItem, 'Reading Details')">
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </ng-template>
                      </kendo-grid-command-column>





                    </kendo-grid>
                    <div style="position: absolute; top: 0; left: -10000px; width: 500px;">
                      <kendo-grid
                        [kendoGridBinding]="mySelectionReadings.length>0 ? mySelectionReadings:readingsgridData.data"
                        #exportiotreadings>
                        <kendo-grid-column [width]="100" field="utilityType" title="Utility Type"></kendo-grid-column>
                        <kendo-grid-column [width]="100" field="deviceSRNO" title="Device Sr No"></kendo-grid-column>
                        <kendo-grid-column [width]="100" field="macAddress" title="Mac Address"></kendo-grid-column>
                        <kendo-grid-column [width]="100" [hidden]="true" field="isMonitoringDevice"
                          title="Monitoring Device"></kendo-grid-column>
                        <kendo-grid-column [width]="100" field="date_Time" title="Date & time" filter="date">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{ dataItem.date_Time | date: 'dd MMM yyyy hh:mm a' }}
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="meterReading" title="Meter reading" [width]="100"></kendo-grid-column>
                        <kendo-grid-column field="meterReadingEB" title="Meter reading EB"
                          [width]="100"></kendo-grid-column>
                        <kendo-grid-column field="meterReadingDG" title="Meter reading DG"
                          [width]="100"></kendo-grid-column>
                        <kendo-grid-column field="meterReadingTS" title="Meter reading TS"
                          [width]="100"></kendo-grid-column>
                        <kendo-grid-column field="onOffStatus" title="On / off status" [width]="80"></kendo-grid-column>
                        <kendo-grid-column field="projectName" title="project name" [width]="100"></kendo-grid-column>
                        <kendo-grid-excel fileName="IotReadings.xlsx"></kendo-grid-excel>
                      </kendo-grid>

                    </div>
                  </div>

                </section>


                }
              </cdk-step>

              <cdk-step [optional]="true">
                <ng-template cdkStepLabel>
                  <span class="number">2.</span>
                  <span>Archived Readings</span>
                </ng-template>
                @if(cdkStepper.selectedIndex === 1){
                <section>
                  <ng-template #template let-anchor>
                    <span>{{ anchor.nativeElement.innerText }}</span>
                  </ng-template>
                  <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
                    (mouseover)="showTooltip($event)">
                    <kendo-grid [data]="archivedgridData" [pageSize]="archived_pageSize" [skip]="archivedSkip"
                      [sortable]="true" [groupable]="false" [selectable]="selectableSettings" [pageable]="{
                                                                                            buttonCount: buttonCount,
                                                                                            info: info,
                                                                                            type: type,
                                                                                            pageSizes: ArchpageSizes,
                                                                                            previousNext: previousNext
                                                                                          }" [reorderable]="true"
                      filterable="menu" [filter]="archivedstate.filter" [sort]="archivedstate.sort"
                      [columnMenu]="{ filter: true }" [resizable]="true" kendoGridSelectBy="id" scrollable="scrollable"
                      (filterChange)="onArchivedFilterChange($event)" (sortChange)="onArchivedSortChange($event)"
                      (pageChange)="archivedDevicePageChange($event)"
                      (selectionChange)="archivedselectionChanged($event)"
                      (dataStateChange)="archivedDataStateChange($event)">


                      <ng-template kendoGridToolbarTemplate>

                        <kendo-grid-spacer></kendo-grid-spacer>
                        <!-- <button [routerLink]="'/payloadConfiguration'" class="btn btn-light" kendoGridAddCommand > 
                                    <span class="fas fa-file-alt"> </span> &nbsp; Add Payload Configurations </button> -->
                        <!-- <button kendoGridPDFCommand class="btn btn-light">
                                                    <span class="fas fa-file-pdf"> </span> &nbsp; Export to PDF</button> -->
                        <button kendoGridExcelCommand class="btn btn-light" (click)="onArchivedExport('Excel')">
                          <span class="fas fa-file-excel"> </span> &nbsp; Export to Excel
                        </button>

                      </ng-template>

                      <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="40"
                        class="no-tooltip"></kendo-grid-checkbox-column>


                      <kendo-grid-column field="deviceSRNO" title="Device Sr No" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="deviceAddress" title="Mac Address" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column [width]="190" field="createdOn" filter="date" title="Created On">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.createdOn | date: 'dd MMM yyyy hh:mm a' }}
                        </ng-template>
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-date-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService">
                          </kendo-grid-date-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="utility" title="Utility" [filterable]="false" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="comment" title="Comment" [filterable]="false" [sortable]="false">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.comment || '-' }}
                        </ng-template>
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-command-column [columnMenu]="false" [width]="100" title="View Details">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <button class="btn btn-primary btn-sm m-lg-auto" kendoTooltip
                            title="View Archived Reading Details"
                            (click)="navigateToViewReadings(dataItem, 'Archived Details')">
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </ng-template>
                      </kendo-grid-command-column>



                    </kendo-grid>

                    <div style="position: absolute; top: 0; left: -10000px; width: 500px;">
                      <kendo-grid
                        [kendoGridBinding]="myArchivedSelectionReadings.length>0 ? myArchivedSelectionReadings:archivedgridData.data"
                        #exportArchived>
                        <kendo-grid-column field="deviceSRNO" title="Device Sr No"></kendo-grid-column>
                        <kendo-grid-column [width]="100" field="deviceAddress" title="Mac Address"></kendo-grid-column>
                        <kendo-grid-column [width]="190" field="createdOn" filter="date" title="Created On">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{ dataItem.createdOn | date: 'dd MMM yyyy hh:mm a' }}
                          </ng-template>
                        </kendo-grid-column>


                        <kendo-grid-column field="utility" title="Utility"></kendo-grid-column>
                        <kendo-grid-column field="comment" title="comment"></kendo-grid-column>

                        <kendo-grid-command-column [columnMenu]="false" [width]="100">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <button class="btn btn-primary btn-sm m-lg-auto "
                              (click)="navigateToViewReadings(dataItem,'Archived Details')">
                              <i class="fas fa-info-circle"></i>
                            </button>
                          </ng-template>
                        </kendo-grid-command-column>
                        <kendo-grid-excel fileName="ArchivedReadings.xlsx"></kendo-grid-excel>
                      </kendo-grid>

                    </div>
                  </div>
                </section>
                }
              </cdk-step>

              <cdk-step [optional]="true">
                <ng-template cdkStepLabel>
                  <span class="number">3.</span>
                  <span>RAW Data</span>
                </ng-template>
                @if(cdkStepper.selectedIndex === 2){
                <section>

                  <ng-template #template let-anchor>
                    <span>{{ anchor.nativeElement.innerText }}</span>
                  </ng-template>
                  <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
                    (mouseover)="showTooltip($event)">
                    <kendo-grid [data]="rawDatagridData" [pageSize]="rawData_pageSize" [skip]="rawSkip"
                      [sortable]="true" [groupable]="false" [selectable]="selectableSettings" [pageable]="{
                                                                         buttonCount: buttonCount,
                                                                       info: info,
                                                                             type: type,
                                                                           pageSizes: ArchpageSizes,
                                                                             }" [reorderable]="true" filterable="menu"
                      [filter]="rawDatastate.filter" [sort]="rawDatastate.sort" [columnMenu]="{ filter: true }"
                      [resizable]="true" kendoGridSelectBy="id" scrollable="scrollable"
                      (filterChange)="onRawDataFilterChange($event)" (sortChange)="onRawDataSortChange($event)"
                      (pageChange)="rawDataPageChange($event)" (selectionChange)="rawDataSelectionChanged($event)"
                      (dataStateChange)="rawDataStateChange($event)">


                      <ng-template kendoGridToolbarTemplate>


                        <!-- <div>
                                                    <kendo-textbox [style.width.px]="250" [(ngModel)]="rawDataSearchValue" [clearButton]="true"
                                                    (valueChange)="clearSearchValueChangeRawData($event)"
                                                    placeholder="Search in all columns...">
                                                </kendo-textbox>
                          
                                                    <button class="btn btn-primary btn-md border-left-none"  (click)="rawFilter($event)">
                                                      <i class="fa fa-search"></i>
                                                    </button>
                                                  </div> -->
                        <kendo-grid-spacer></kendo-grid-spacer>

                        <button kendoGridExcelCommand class="btn btn-light" (click)="onRawExport('Excel')">
                          <span class="fas fa-file-excel"> </span> &nbsp; Export to Excel
                        </button>

                      </ng-template>






                      <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="40"
                        class="no-tooltip"></kendo-grid-checkbox-column>
                      <kendo-grid-column field="deviceSRNO" title="Device Sr No" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="deviceAddress" title="Mac Address" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="receivedTime" filter="date" title="Date & time">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.receivedTime | date: 'dd MMM yyyy hh:mm a' }}
                        </ng-template>
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-date-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService">
                          </kendo-grid-date-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-column field="utility" title="Utility" [filterable]="false" [sortable]="false">
                        <!-- Filter code starts -->
                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                          let-filterService="filterService">
                          <kendo-grid-string-filter-menu [column]="column" [filter]="filter"
                            [filterService]="filterService" [extra]="false" [operator]="'eq'">
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                            <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
                            <!-- <kendo-filter-endswith-operator></kendo-filter-endswith-operator> -->
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                        <!-- Filter code ends -->
                      </kendo-grid-column>

                      <kendo-grid-command-column [columnMenu]="false" title="View Details" [width]="100">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <button class="btn btn-primary btn-sm m-lg-auto" kendoTooltip title="View Raw Data Details"
                            (click)="navigateToViewReadings(dataItem, 'RAW Data Details')">
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </ng-template>
                      </kendo-grid-command-column>



                      <!-- <kendo-grid-column  field="deviceSRNO" title="Device Sr. No"></kendo-grid-column>
                                            <kendo-grid-column  field="deviceAddress"
                                            title="Mac Address"></kendo-grid-column>
                                            <kendo-grid-column  field="receivedTime" filter="date" title="Date & time">
                                                <ng-template kendoGridCellTemplate let-dataItem>
                                                    {{ dataItem.receivedTime | date: 'dd MMM yyyy hh:mm a' }}
                                                </ng-template>
                                            </kendo-grid-column>
                                            <kendo-grid-column field="utility" title="Utility"></kendo-grid-column>
                                            <kendo-grid-command-column  [columnMenu]="false"  title="View Details"    [width]="100" 
                                                >
                                                <ng-template kendoGridCellTemplate let-dataItem>
                                                    <button class="btn btn-primary btn-sm m-lg-auto "  kendoTooltip  title="View Raw  Details"
                                                        (click)="navigateToViewReadings(dataItem,'RAW Data Details')">
                                                        <i class="fas fa-info-circle"></i>
                                                    </button>
                                                </ng-template>
                                            </kendo-grid-command-column> -->


                    </kendo-grid>

                    <div style="position: absolute; top: 0; left: -10000px; width: 500px;">
                      <kendo-grid
                        [kendoGridBinding]="myrawDataSelectionReadings.length>0 ? myrawDataSelectionReadings:rawDatagridData.data"
                        #hiddenRawGrid>
                        <kendo-grid-column field="deviceSRNO" title="Device Sr No"></kendo-grid-column>
                        <kendo-grid-column [width]="100" field="deviceAddress" title="Mac Address"></kendo-grid-column>
                        <kendo-grid-column [width]="190" field="receivedTime" filter="date" title="Date & time">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{ dataItem.receivedTime | date: 'dd MMM yyyy hh:mm a' }}
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="utility" title="Utility"></kendo-grid-column>
                        <kendo-grid-command-column [columnMenu]="false" [width]="100">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <button class="btn btn-primary btn-sm m-lg-auto "
                              (click)="navigateToViewReadings(dataItem,'RAW Data Details')">
                              <i class="fas fa-info-circle"></i>
                            </button>
                          </ng-template>
                        </kendo-grid-command-column>
                        <kendo-grid-excel fileName="RawData.xlsx"></kendo-grid-excel>
                      </kendo-grid>

                    </div>
                  </div>
                </section>
                }
              </cdk-step>

            </ng-stepper>
          </div>



        </div>
      </div>
    </div>
  </div>

</div>